var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2308 1.5L15.495 12H8.96653L12.2308 1.5Z",
    fill: "url(#paint0_linear_1198_74118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2308 22.5L8.96654 12L15.495 12L12.2308 22.5Z",
    fill: "url(#paint1_linear_1198_74118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1198_74118",
    x1: 7.92456,
    y1: 16.2846,
    x2: 17.1841,
    y2: 15.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1198_74118",
    x1: 16,
    y1: 15.4997,
    x2: 8.46156,
    y2: 15.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCompass);
export default __webpack_public_path__ + "static/media/color-compass.a72c9599999c02dba17d519f788e6e7a.svg";
export { ForwardRef as ReactComponent };